import * as React from 'react';
import { useTimeFilterContext } from '../context/TimeFilterContext/TimeFilterContext.js';
import { isWithinTimeSpan } from '../utils/datetime.js';

const timeStringToNumbers = (timeString)=>timeString.split(':').map((part)=>parseInt(part, 10)
    )
;
const isValidHoursInput = (numbers)=>numbers.length === 2
;
const getFilterDate = (baseDate, timeString)=>{
    let date = null;
    const numbers = timeStringToNumbers(timeString);
    if (isValidHoursInput(numbers)) {
        date = new Date(baseDate) // Create a date on the same day as the provided date
        ;
        date.setHours(...numbers) // Set the time to the filter time
        ;
    }
    return date;
};
const getFilterDates = (baseDate, fromTimeString, untilTimeString)=>{
    const filterFromDate = getFilterDate(baseDate, fromTimeString);
    const filterUntilDate = getFilterDate(baseDate, untilTimeString);
    if (!filterFromDate || !filterUntilDate) {
        throw new Error(`Invalid filter value(s) passed: ${fromTimeString} & ${untilTimeString}`);
    }
    return {
        filterFromDate,
        filterUntilDate
    };
};
const useActiveTimeFilters = ()=>{
    const [, { active , options  }] = useTimeFilterContext();
    const activeOptions = React.useMemo(()=>options.filter((option)=>active[option.name]
        )
    , [
        active,
        options
    ]);
    const getAvailabilityTimeFilters = React.useCallback((date = new Date())=>{
        if (!activeOptions.length) {
            return {
                startTime: undefined,
                endTime: undefined
            };
        }
        const optionDates = activeOptions.map((option)=>[
                getFilterDate(date, option.from),
                getFilterDate(date, option.until)
            ]
        ).reduce((acc, [from, until])=>{
            if (from) {
                acc.push(from);
            }
            if (until) {
                acc.push(until);
            }
            return acc;
        }, []).sort((a, b)=>a.getTime() - b.getTime()
        );
        const first = optionDates[0];
        const [last] = optionDates.slice(-1);
        return {
            startTime: first,
            endTime: last
        };
    }, [
        activeOptions
    ]);
    const activeFilters = React.useMemo(()=>activeOptions.map((option)=>{
            return (from)=>{
                const { filterFromDate , filterUntilDate  } = getFilterDates(from, option.from, option.until);
                if (!filterFromDate || !filterUntilDate) {
                    throw new Error(`Invalid filter value(s) passed for ${option.name}: ${option.from} & ${option.until}`);
                }
                return isWithinTimeSpan(from, filterFromDate, filterUntilDate);
            };
        })
    , [
        activeOptions
    ]);
    return React.useMemo(()=>[
            {
                getAvailabilityTimeFilters
            },
            {
                activeFilters
            }
        ]
    , [
        getAvailabilityTimeFilters,
        activeFilters
    ]);
};
var useActiveTimeFilters$1 = useActiveTimeFilters;

export { useActiveTimeFilters$1 as default, useActiveTimeFilters };
//# sourceMappingURL=use-active-time-filters.js.map
